var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"value":_vm.myValue}},'el-select',_vm.myAttr,false),_vm.myListener),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.value,attrs:{"value":item.value,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }